import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CustomControl from '../../../../../../../../components/global/CustomControl';
import EventAddonItemInformationModal from '../../../../../FreemiumEventPurchase/components/EventAddonItemInformationModal';
import InfoCircleIcon from '../../../../../../../../components/icons/InfoCircleIcon';
import Button from '../../../../../../../../components/global/Button';
import { GIFTING_EVENT_ADDON_ITEMS_META } from '../../../../../../views/AlbumFolder/FreemiumEvents/Settings/FreemiumEventGiftingSettings/components/GiftingEventAddonItemsSelector/constants';
import { formatPriceForDisplay } from '../../../../../../../../util/format-money';
import Badge from '../../../../../../../../components/global/Badge';
import { sortEventAddonItemsByPriority } from '../../../../helpers';

const propTypes = {
  eventAddonItems: PropTypes.array.isRequired,
  onToggleEventAddonItem: PropTypes.func.isRequired,
  selectedEventAddonItemIds: PropTypes.array.isRequired,
  className: PropTypes.string,
};

const GiftingEventAddonItemsPurchaseSelector = ({
  eventAddonItems,
  onToggleEventAddonItem,
  selectedEventAddonItemIds,
  className,
  disabled,
}) => {
  const [howItWorksModalOpen, setHowItWorksModalOpen] = useState(false);
  const [selectedEventAddonItemMeta, setSelectedEventAddonItemMeta] = useState(
    null,
  );
  if (!eventAddonItems || eventAddonItems.length === 0) {
    return null;
  }

  const classes = classNames({
    'gifting-event-addon-items-purchase-selector': true,
    [className]: !!className,
  });

  const sortedEventAddonItems = sortEventAddonItemsByPriority(eventAddonItems);

  return (
    <div className={classes}>
      {sortedEventAddonItems.map(eventAddonItem => {
        const meta = GIFTING_EVENT_ADDON_ITEMS_META[eventAddonItem.types[0]];
        const selected = selectedEventAddonItemIds.includes(eventAddonItem.id);

        const itemClasses = classNames({
          'gifting-event-addon-items-purchase-selector-item': true,
          selected,
        });

        return (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events
          <div
            key={eventAddonItem.id}
            data-testid={eventAddonItem.types[0]}
            tabIndex="-1"
            role="button"
            className={itemClasses}
            onClick={() => {
              if (disabled) {
                return;
              }

              onToggleEventAddonItem(eventAddonItem);
            }}
          >
            <div className="gifting-event-addon-items-selector-content">
              <img src={meta.thumbnailSrc} alt={meta.title} />
              <div className="gifting-event-addon-items-selector-overlay" />
              <div className="gifting-event-addon-items-selector-copy">
                <h2 className="mb-1 text-white">{meta.title}</h2>
                <Badge badgeStyle="white" badgeOutline>
                  ${formatPriceForDisplay(eventAddonItem.price.value)}
                </Badge>
              </div>
              <div className="gifting-event-addon-items-selector-info-section">
                <Button
                  btnStyle="reset"
                  onClick={e => {
                    e.stopPropagation();
                    setHowItWorksModalOpen(true);
                    setSelectedEventAddonItemMeta(meta);
                  }}
                >
                  <InfoCircleIcon size={24} />
                </Button>
                <CustomControl
                  id={`checkbox-event-addon-item-${eventAddonItem.id}`}
                  checked={selected}
                  onClick={e => e.stopPropagation()}
                  label={meta.title}
                  readOnly
                  labelSrOnly
                  type="checkbox"
                  size="lg"
                  className="ml-2 mr-0"
                  disabled={disabled}
                />
              </div>
            </div>
            <p className="text-light mt-1 mb-0">{meta.description}</p>
          </div>
        );
      })}
      <EventAddonItemInformationModal
        forceOpen={howItWorksModalOpen && !!selectedEventAddonItemMeta}
        assetUrl={selectedEventAddonItemMeta?.howItWorks?.assetUrl}
        title={`Learn more about ${selectedEventAddonItemMeta?.title}!`}
        onClose={event => {
          event.preventDefault();
          event.stopPropagation();
          setHowItWorksModalOpen(false);
        }}
      />
    </div>
  );
};

GiftingEventAddonItemsPurchaseSelector.propTypes = propTypes;

export default GiftingEventAddonItemsPurchaseSelector;
